import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import Table from '../Table/Table';
import FlexWrapper from '../../layouts/FlexWrapper';
import { Search, User } from 'react-feather';
import useWindowDimensions, { useRemote } from '../../Utils/Utils';
import SimpleSearchFilter, { filterBy } from '../Input/SimpleSearchFilter';


const SwitchCompanyModal = ({ handleClose, confirmButton, tenants, user, setTenants }) => {
	const remote = useRemote()
	const height = useWindowDimensions().height
	const [searchTerm, setSearchTerm] = useState("");
	const [markedAccounts, setMarkedAccounts] = useState(0)

	useEffect(() => {
		const tenantsBookedmarked = tenants.filter(t => t.isBookmarked)
		setMarkedAccounts(tenantsBookedmarked.length)
	}, [tenants])

	function filter(dataToFilter, searchTerm) {
		if (searchTerm === null || searchTerm.trim().size === 0) {
			return dataToFilter
		}
		return dataToFilter.filter((datum) => filterBy(datum, ['companyName'], searchTerm))
	}

	function updateBookMark(tenant) {
		remote.put(`/crm/tenants/bookmark`, { ...tenant, isBookmarked: !tenant.isBookmarked }).then(resp => {
			const sortedTenants = resp.sort((a, b) => {
				const tenant1 = a.isBookmarked ? 1 : 0
				const tenant2 = b.isBookmarked ? 1 : 0
				return tenant2 - tenant1
			})
			setTenants(sortedTenants)
		})
	}

	const currentCompany = tenants.filter(t => t.companyId === user.companyId)
	const otherCompanies = tenants.filter(t => t.companyId !== user.companyId)

	const tableMapping = (data, showUserIcon) => data && data.map((item) => {
		return <tr>
			<td style={{ width: 'calc(100% - 4rem)', paddingLeft: 0 }}>
				<FlexWrapper>
					{showUserIcon && <User color="#0E8EFD" style={{ marginRight: "0.5rem" }} />}
					<FlexWrapper align='baseline'>
						<p>{item.companyName}</p>
						<p className='ml-s opacity-05 font-size-body-s'>{item.roleDTO?.displayName}</p>
					</FlexWrapper>
				</FlexWrapper>
			</td>
			<td style={{ width: '4rem', textAlign: "right" }}>
				<i onClick={() => updateBookMark(item)} className={item.isBookmarked ? 'cursor-pointer material-icons colour-text-primary' : 'cursor-pointer material-symbols-outlined'}>bookmark</i>
			</td>
		</tr>
	})

	return (
		<Modal
			header={
				<FlexWrapper align="center">
					<span className="material-symbols-outlined" style={{ color: "#0E8EFD", marginRight: "0.5rem", fontSize: "28px" }} >swap_horiz</span>
					Switch Account
				</FlexWrapper>
			}
			handleClose={handleClose}
			confirmButton={{ ...confirmButton }}
			overlayStyle={{ paddingBottom: '2rem', paddingTop: '2rem' }}
		>
			<FlexWrapper className='mb-m' direction='column' gap='l' align='baseline'>
				<p className='font-size-body-s font-weight-semi-bold'>{`Bookmarked accounts: ${markedAccounts}/${tenants.length}`}</p>
				<p className='opacity-05 font-size-body-s font-weight-semi-bold'>Current Account</p>
			</FlexWrapper>
			<Table
				dataMap={tableMapping(currentCompany, true)}
			/>
			<FlexWrapper className='mt-xl mb-s' justify={"space-between"}>
				<p className='opacity-05 font-size-body-s font-weight-semi-bold'>{'Available Accounts (' + otherCompanies.length + ')'}</p>
				<SimpleSearchFilter
					size='small'
					width='l'
					placeholder={`Search account`}
					isClearable
					icon={<Search />}
					setSearchTerm={setSearchTerm}
					searchTerm={searchTerm}
				/>
			</FlexWrapper>
			<Table
				dataMap={tableMapping(filter(otherCompanies, searchTerm))}
				wrapperStyle={{ height: height > 1200 ? 61 * (tenants.length - 1) : height > 900 ? tenants.length >=8 ? 490 : 60 * (tenants.length - 1) : height < 600 ? '62px' : '30vh'}}
			/>
		</Modal>
	);
}
export default SwitchCompanyModal;